import React from "react";
import { Box, Flex, Text, Divider } from "@chakra-ui/react";
import { FaExclamationCircle } from "react-icons/fa";
import { ChevronRightIcon } from "@chakra-ui/icons";
import moment from "moment";

interface Notification {
  referenceNumber: string | number;
  type: string;
  referenceId: string | number;
  description: string;
  dateCreated: string | number;
}

interface NotificationListProps {
  notifications: Notification[];
  onItemClick: (referenceNumber: any, type: any, referenceId: any) => void;
  maxHeight?: string;
}

const NotificationList: React.FC<NotificationListProps> = ({
  notifications,
  onItemClick,
  maxHeight = "400px",
}) => {
  return (
    <>
      <Box
        p="12px 15px"
        borderBottom="1px solid"
        borderColor="gray.100"
        bg="gray.50"
      >
        <Text fontWeight="700" fontSize="md" color="blue.400">
          Notifications ({notifications.length})
        </Text>
      </Box>
      <Box
        maxH={maxHeight}
        overflowY="auto"
        css={{
          "&::-webkit-scrollbar": {
            width: "6px",
          },
          "&::-webkit-scrollbar-track": {
            background: "#f1f1f1",
          },
          "&::-webkit-scrollbar-thumb": {
            background: "var(--clr1)",
            borderRadius: "10px",
          },
          "&::-webkit-scrollbar-thumb:hover": {
            background: "var(--clr1)",
          },
        }}
      >
        {notifications.map((item, index) => (
          <Box key={index}>
            <Box
              display="flex"
              alignItems="start"
              justifyContent="space-between"
              padding="12px 15px"
              cursor="pointer"
              transition="background 0.2s"
              _hover={{
                background: "blue.50",
              }}
              onClick={() =>
                onItemClick(item.referenceNumber, item.type, item.referenceId)
              }
            >
              <Flex align="start" flex="1">
                <Box mt="2px" mr="12px">
                  <FaExclamationCircle fontSize="18px" color="var(--clr1)" />
                </Box>
                <Box flex="1">
                  <Text
                    fontSize="14px"
                    fontWeight="600"
                    color="gray.800"
                    lineHeight="1.4"
                  >
                    {item.description}
                  </Text>
                  <Text
                    mt="4px"
                    fontSize="12px"
                    fontWeight="500"
                    color="gray.500"
                  >
                    {moment(item.dateCreated).format("Do MMMM, h:mm A")}
                  </Text>
                </Box>
              </Flex>
              <Box pl="8px" alignSelf="center">
                <ChevronRightIcon fontSize="20px" color="gray.400" />
              </Box>
            </Box>
            <Divider borderColor="gray.50" />
          </Box>
        ))}
      </Box>
    </>
  );
};

export default NotificationList;
